<template>
    <button :class="{ scaleNormal: normalScale }" class='wb' @click="handleClick"><slot></slot></button>
</template>
<script>
export default {
  props: ['delay'],
  data () {
    return {
      normalScale: false
    }
  },
  methods: {
    hide () {
      this.normalScale = true
    },
    handleClick (ev) {
      ev.preventDefault()
      ev.stopPropagation()

      this.hide()
      this.$emit('wb-welcome')
    }
  },
  mounted () {
    setTimeout(this.hide, this.delay || 3000)
  },
  components: {}
}
</script>

<style lang="less" scoped>
@import "../css/globals.less";

.wb {
  outline: 0;
  opacity: 1;
  border: solid 0.1em rgba(75, 55, 22, 0.25);
  border-radius: 1em;
  font-family: Tangerine, serif;
  font-size: 30pt;
  background-color: rgba(235, 216, 182, 0.808);
  color: black;
  padding: 0.25em;
  position: absolute;
  margin: auto auto;
  width: 5em;
  height: 2em;
  z-index: 101;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  transition: transform 0.6s ease-in-out;
  transform: scale(0);
}

.wb:hover {
  border: solid 0.17em rgba(199, 139, 89, 0.486);
}

.wb.scaleNormal {
  transform: scale(1);
}
</style>


// WEBPACK FOOTER //
// src/components/WelcomeButton.vue